export const sanitizePhoneNumber = (phone) => phone && "+" + phone.replace(/\D/g, "");

const _autoPlural = (word) => { /* todo: improve it to add other languages support */
	if (word.endsWith("y") && !/[aeiou]y$/i.test(word)) return word.slice(0, -1) + "ies";
	else if (/(s|x|z|ch|sh)$/.test(word)) return word + "es";
	else if (word.endsWith("f")) return word.slice(0, -1) + "ves";
	else if (word.endsWith("fe")) return word.slice(0, -2) + "ves";
	else return word + "s";
};

export const pluralize = (value, text) => {
	const words = text.trim().split(/\s+/);
	if (words.length === 0) return `${value}`;

	const lastWord = words.pop();
	const pluralWord = value === 1 ? lastWord : _autoPlural(lastWord);
	return `${value} ${[...words, pluralWord].join(" ")}`;
};

export const toCamelCase = (word) => word
	.replace(/[-_ ]+(\w)/g, (_, c) => c ? c.toUpperCase() : "")
	.replace(/^\w/, (c) => c.toLowerCase());

export const toKebabCase = (word) => word
	.replace(/([A-Z])/g, "-$1") // Add a hyphen before each uppercase letter
	.toLowerCase() // Convert the entire string to lowercase
	.replace(/^-/, ""); // Remove any leading hyphen if it exists (for the first word)

export const trimTrailingSlash = (text) => {
	if (text.endsWith("/")) return text.slice(0, -1);
	return text;
};

export default {
	pluralize,
	sanitizePhoneNumber,
	toCamelCase,
	toKebabCase,
	trimTrailingSlash
};